import Axios from '@/plugins/Axios';

import {
  AddressHistory,
  GetSinglePatientResponse,
  GetUserDataInterface,
  UserAddress,
  UserAddressId,
  GetUserB2BDataInterface,
  DeleteUserPayload,
} from '@/types';
import {
  generateQueryParamsFromObjectQuery,
  ObjectQueryParams,
} from '@/utils/helper';
import { AxiosResponse } from 'axios';

const endpoint = '/user';
const doctorEndpoint = '/b2b/user';

const userApi = {
  getUserB2B: () => Axios().get<GetUserB2BDataInterface>(`/b2b${endpoint}`),
  getUser: () => Axios().get<GetUserDataInterface>(`${endpoint}`),
  addUserAddress: (data: UserAddress) =>
    Axios().post<UserAddressId>(`${endpoint}/address`, data),
  getSinglePatient: (patientId: number) =>
    Axios().get<GetSinglePatientResponse>(`${endpoint}/patient/${patientId}`),
  getUserAddressHistory: (queryParams: ObjectQueryParams) =>
    Axios().get<AddressHistory[]>(
      `${endpoint}/address${generateQueryParamsFromObjectQuery(queryParams)}`
    ),
  getSavedUserAddress: (queryParams: ObjectQueryParams) =>
    Axios().get<AddressHistory[]>(
      `${endpoint}/address/saved${generateQueryParamsFromObjectQuery(
        queryParams
      )}`
    ),
  deleteUser: (payload: DeleteUserPayload, token: string) =>
    Axios().delete(`${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    }),
  deleteUserDoctor: (payload: DeleteUserPayload, token: string) =>
    Axios().delete(`${doctorEndpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    }),
};

export default userApi;
